import { createFileRoute, redirect } from "@tanstack/react-router";
export const Route = createFileRoute("/scottsdale")({
  beforeLoad: () => { throw redirect({ to: "/scottsdale-roofing-contractor", statusCode: 301 }); },
});
